import htmx from "htmx.org";
import enterView from "enter-view";
// import imagesLoaded from "imagesloaded";

export function getScrollTop() {
    const supportPageOffset = window.pageXOffset !== undefined,
        isCSS1Compat = (document.compatMode || "") === "CSS1Compat";

    return supportPageOffset
        ? window.pageYOffset
        : isCSS1Compat
        ? document.documentElement.scrollTop
        : document.body.scrollTop;
}

export function animateInViewEls(selector, inViewClass, offset) {
    enterView({
        selector: selector,
        offset: offset,
        once: true,
        enter: (el) => {
            if (el.dataset.watchdelay) {
                // Add class after delay period
                setTimeout(() => {
                    el.classList.add(inViewClass);
                }, parseFloat(el.dataset.watchdelay));
            } else {
                // Add class immediately
                el.classList.add(inViewClass);
            }
        },
    });
}

export function scrollToTarget(selector, offsetY = 0) {
    const triggers = document.querySelectorAll(selector);

    triggers.forEach((el) => {
        el.addEventListener("click", (e) => {
            e.preventDefault();

            // Get the target elements
            const targetEl = document.querySelector(el.dataset.target),
                targetElOffsetTop = targetEl.offsetTop;

            window.scroll({
                top: targetElOffsetTop - offsetY,
                left: 0,
                behavior: "smooth",
            });
        });
    });
}

export function autoScrollToTarget(selector, offsetY = 0) {
    // Get the target element
    const targetEl = document.querySelector(selector),
        targetElOffsetTop = targetEl.offsetTop;

    window.scroll({
        top: targetElOffsetTop - offsetY,
        left: 0,
        behavior: "smooth",
    });
}

export function buildPage() {
    // const content = document.querySelector(".js-content");

    // imagesLoaded(content, showPage);
    showPage();
}

export function showPage() {
    // Auto scroll to results on search results page
    if (document.querySelector(".js-search-results")) {
        setTimeout(() => {
            autoScrollToTarget(".js-search-results", 30);
        }, 1000);
    }

    // Setup in-view element watching
    if (document.querySelector(".js-watch")) {
        animateInViewEls(".js-watch", "in-view", 0.06);
    }

    if (document.querySelector(".js-watch--opacity")) {
        animateInViewEls(".js-watch--opacity", "in-view", 0.06);
    }

    htmx.on("htmx:afterSwap", function (event) {
        animateInViewEls(".js-watch--opacity", "in-view", 0.06);
    });
}

export function isTouchDevice() {
    return document.documentElement.classList.contains("touchevents");
}

export function slideUp(target, duration = 500) {
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.boxSizing = "border-box";
    target.style.height = target.offsetHeight + "px";
    target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;

    window.setTimeout(() => {
        target.style.display = "none";
        target.style.removeProperty("height");
        target.style.removeProperty("padding-top");
        target.style.removeProperty("padding-bottom");
        target.style.removeProperty("margin-top");
        target.style.removeProperty("margin-bottom");
        target.style.removeProperty("overflow");
        target.style.removeProperty("transition-duration");
        target.style.removeProperty("transition-property");
    }, duration);
}

export function slideDown(target, duration = 500) {
    target.style.removeProperty("display");
    let display = window.getComputedStyle(target).display;

    if (display === "none") {
        display = "block";
    }

    target.style.display = display;

    let height = target.offsetHeight;

    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = "border-box";
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.height = height + "px";
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");

    window.setTimeout(() => {
        target.style.removeProperty("height");
        target.style.removeProperty("overflow");
        target.style.removeProperty("transition-duration");
        target.style.removeProperty("transition-property");
    }, duration);
}
